// extracted by mini-css-extract-plugin
module.exports = {"activeContainer":"styles_activeContainer__YwfQT","container":"styles_container__zwRV2","activeTitle":"styles_activeTitle___AHsm","title":"styles_title__9KLLI"};